import { StringArrayFormatOptions } from "shared/api/api";

/**
 * Row key under which the v2 list endpoint returns the matched-event counts
 * map ({ "<otherEventType>": count }) for event schemas that have a primary key.
 */
export const MATCHED_EVENT_COUNTS_KEY = "matchedEventCounts";
/**
 * Row key for a record's AI summary. Auto-injected (snake_case) on event schemas
 * with `hasAiSummary` enabled.
 */
export const AI_SUMMARY_KEY = "ai_summary";
/**
 * Row key under which smart groups are preloaded (as objects) on event schemas
 * with `smartGrouping` enabled.
 */
export const SMART_GROUPS_KEY = "smartGroups";

export const SMART_GROUPS_DEFAULT_FORMAT: StringArrayFormatOptions = {
  separator: ", ",
  style: "text",
  maxItems: null,
};

export const RECORDS_PER_PAGE = 20;

export const INITIAL_SMART_GROUP_COUNT = 25;
export const ADDITIONAL_LOAD_COUNT = 10;

export enum SchemaSmartGroupCountType {
  EVENT_COUNT = "EVENT_COUNT",
  ASSET_COUNT = "ASSET_COUNT",
}
